<template>
    <section class="flex font-poppins md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <section class="w-screen pl-10 pr-10">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-sm">Dashboard</p>
                    </div>

                    <div class=" mr-10 md:mt-4">
                        <Notification/>
                    </div>
                </div>
            </section>

            <div class="flex mt-8 mb-8 cursor-pointer" @click="goBack">
                <i class="fa fa-arrow-left"></i>
                <p class="ml-4">Go back</p>
            </div>
            <div class=" flex md:flex-col bg-gray-100">
                <PieChart/>
                <div class="text-blue-600 mt-4 p-2">
                    <div class="flex mt-2">
                        <p class="w-5 h-3 bg-blue-600 mt-1"></p>
                        <div class="ml-3">
                            <p>Send a Package</p>
                            <p class="font-semibold">NGN {{packageIncome.sendAPackageTotalCost}}</p>
                        </div>
                    </div>
                     <div class="flex mt-2">
                        <p class="w-5 h-3 bg-red-600 mt-1"></p>
                        <div class="ml-3">
                            <p>Buy For Me</p>
                            <p class="font-semibold">NGN {{packageIncome.buyForMeTotalCost}}</p>
                        </div>
                    </div>
                     <div class="flex mt-2">
                        <p class="w-5 h-3 bg-yellow-600 mt-1"></p>
                        <div class="ml-3">
                            <p>Haulage</p>
                            <p class="font-semibold">NGN {{packageIncome.haulageTotalCost}}</p>
                        </div>
                    </div>
                    <div class="flex mt-2">
                        <p class="w-5 h-3 bg-green-600 mt-1"></p>
                        <div class="ml-3">
                            <p>Rides</p>
                            <p class="font-semibold">NGN {{packageIncome.bookARideTotalCost}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import axios from 'axios'
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import PieChart from './PieChart.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components : {
        GetDate,
        Notification,
        AdminDashboardNav,
        PieChart
    },
    data() {
        return {
            totalMonthlyHaulage : "",
            totalMonthlyPackage : "",
            totalMonthlyBuyForMe : "",
            totalMonthlyRide: "",
            token: localStorage.getItem("token"),
            packageIncome: [],
            id: localStorage.getItem("userId")
        }
    },

    mounted() {
        this.getMonthlyTotalHaulage();  
        this.getMonthlyTotalPackage(); 
        this.getMonthlyBuyForMe();  
        this.getMonthlyTotalRide();
        this.getPackageIncome();
        this.networkError();
    },

    methods: {
         goBack() {
            this.$router.go(-1)
        },

        getMonthlyTotalPackage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=package&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyPackage = total.total
                this.statsMonthlyPackage = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyTotalHaulage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=haulage&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyHaulage = total.total
                this.statsMonthlyHaulage = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyBuyForMe() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=buyForMe&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyBuyForMe = total.total
                this.statsMonthlyBuyForMe = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyTotalRide() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=bookARide&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyRide = total.total
                this.statsMonthlyRide = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },


            getPackageIncome() {
                let id = localStorage.getItem("userId")
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/income/${id}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.packageIncome = response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>